<div class="toast-container">
  <div
    *ngFor="let toast of toasts; trackBy: trackById"
    class="toast-item"
    [class]="'toast-item toast-' + toast.type"
  >
    <div class="toast-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path *ngIf="toast.type === 'success'" [attr.d]="iconPath('success')"/>
        <g *ngIf="toast.type === 'error'">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </g>
        <g *ngIf="toast.type === 'warning'">
          <path d="M12 9v4"/>
          <path d="M12 17h.01"/>
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
        </g>
        <g *ngIf="toast.type === 'info'">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="16" x2="12" y2="12"/>
          <line x1="12" y1="8" x2="12.01" y2="8"/>
        </g>
      </svg>
    </div>

    <div class="toast-body">
      <p class="toast-title">{{ toast.title }}</p>
      <p class="toast-message">{{ toast.message }}</p>
    </div>

    <button class="toast-close" (click)="remove(toast.id)">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

    <div class="toast-progress" [style.animation-duration]="toast.duration + 'ms'"></div>
  </div>
</div>
